export enum buildTypesEnum {
  BUSINESS = 'businessProfile',
  DATA = 'dataProfile',
}
